import { useContext, useEffect, useState } from "react";
import MenuComponent from "../../../menu/menu";
import "./talent-sauce-drop-resume.scss";
import { DropResumeModel } from "../../../../model/guest/drop-resume/drop-resume.model";
import { Alert, Autocomplete, CircularProgress, FormControl, Snackbar, TextField, TextareaAutosize } from "@mui/material";
import { useFilePicker } from "use-file-picker";
import { Button } from "react-bootstrap";
import JOB_ROLE_JSON from "../../../../assets/json/job-role-suggestion.json"
import { JobRole, JobRoleSuggestionModel } from "../../../../model/job-role-suggestion.model";
import { ProvideContext } from "../../../../context/provider.context";
import { TranslateModel } from "../../../../model/translate.model";
import { TextFields } from "@mui/icons-material";
import IMAGE_COVER from "../../../../assets/images/talent-sauce/cover-drop-resume.jpg"
import IMAGE_T from "../../../../assets/images/talent-sauce/T.png";
import IMAGE_S from "../../../../assets/images/talent-sauce/S.png";
import { InputDropResumeModel } from "../../../../model/guest/drop-resume/input-drop-resume.model";
import DropResumeService from "../../../../services/drop-resume/drop-resume.service";
import ApiService from "../../../../services/api.service";
import UtilityService from "../../../../utility/utility.service";
import { useLocation } from "react-router-dom";
import config from "../../../../config";

const TalentSauceDropResumeComponent = () => {
    const { translateGlobal }: any = useContext(ProvideContext)
    const [translate, setTranslate] = useState<TranslateModel>(translateGlobal);
    const [flattenedRoles, setFlattenedRoles] = useState(new Array());
    const [files, setFiles] = useState<any>(new Array()); // Initialize with one empty skill field
    const [isSaving, setIsSaving] = useState(false);
    const [isModalSnack, setIsModalSnack] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [pathName, setPathName] = useState("");
    const location = useLocation();
    const [errorsJson, setErrors] = useState({
        email: '',
        resume: '',
        salary: '',
        introduce: '',
        jobRole: ''
    });
    const [inputModel, setInputModel] = useState<DropResumeModel>({
        email: '',
        introduction: '',
        jobRole: '',
        salary: ''
    });
    const {openFilePicker, filesContent, loading, errors, clear } = useFilePicker({
        multiple: false,
        readAs: 'DataURL',
        accept: ['image/*', '.pdf'],
        limitFilesConfig: { min: 0, max: 1 },
        maxFileSize: 20,
        onFilesSelected: ({ plainFiles, filesContent, errors }) => {
            // this callback is always called, even if there are errors
            setFiles(filesContent)
            const inputMod = { ...inputModel }
            inputMod.resume = filesContent[0].name;
            setInputModel(inputMod);
        },
        onFilesRejected: ({ errors }) => {
            // this callback is called when there were validation errors
        }
    });

    useEffect(() => {
        if(location.pathname.includes("drop-resume-campaign-hackaton")){
            setPathName("Hackaton Campaign")
        }
    },[location])

    const clearFile = () => {
        clear()
    }

    const handleCloseModalSnack = () => {
        setIsModalSnack(false);
    }

    const reset = () => {
        const inputMod = { ...inputModel };
        inputMod.email = '';
        inputMod.introduction = '';
        inputMod.jobRole = '';
        inputMod.salary = '';
        setFiles(null);
        setInputModel(inputMod);

    }

    useEffect(() => {
        getRoleOptions();
        // getJobRole();
    }, [])

    const getJobRole = () => {

        ApiService().getJobRolesSuggestion().then((res) => {

            if (res) {
            }
        })
    }

    const DataURIToBlob = (dataURI: string) => {
        const splitDataURI = dataURI.split(',')
        const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
        const mimeString = splitDataURI[0].split(':')[1].split(';')[0]
        const ia = new Uint8Array(byteString.length)
        for (let i = 0; i < byteString.length; i++)
            ia[i] = byteString.charCodeAt(i)
        return new Blob([ia], { type: mimeString })
    }

    function getRoleOptions() {
        let flatItem = new Array();
        JOB_ROLE_JSON.map((item: JobRoleSuggestionModel) => {

            const jobPush = {
                label: item.category,
                options: new Array()
            }
            let strgArray = new Array();
            item.job_roles.map((items: JobRole) => {

                if (items.job_title) {
                    strgArray.push(items.job_title);
                }

            })
            jobPush.options = strgArray;
            flatItem.push(jobPush);

        })
        setFlattenedRoles(flatItem)
    }

    const clickSubmit = () => {
        setIsSaving(true);
        let isError = false;
      
        if(errorsJson.email.length > 0 && errorsJson.introduce.length > 0
            && errorsJson.jobRole.length > 0 && errorsJson.resume.length > 0
            && errorsJson.salary.length > 0){
                isError = true;
            }

        if (!isError && filesContent.length > 0 && inputModel.email && inputModel.introduction && inputModel.jobRole && inputModel.resume && inputModel.salary) {
            const file = DataURIToBlob(filesContent[0]["content"]);
            setIsSubmitting(true);
            const introduction = pathName ? "(Hackathon Campaign)\n\n"+inputModel.introduction : inputModel.introduction;
            DropResumeService().uploadResumeOneProfile(file, filesContent[0].name, config.resume_builder.upload_resume.type).then((res) => {
                if (res.resume_key) {
                    const objectResult: InputDropResumeModel = {
                        email: inputModel.email,
                        expected_salary: Number(inputModel.salary),
                        introduction: introduction,
                        preferred_job_role: inputModel.jobRole,
                        resume_key: res.resume_key
                    }
                    DropResumeService().postDropResume(objectResult).then((result) => {

                        if (result) {
                            UtilityService().clickSendEvent("drop_resume_talentsauce_complete", "submit");
                            setIsSaving(false);
                            setIsSubmitting(false);
                            setIsModalSnack(true);
                            reset();
                        }
                    }).catch((err) => {
                        setIsSaving(false);
                        setIsSubmitting(false);
                    })
                }

            }).catch((err) => {
                setIsSaving(false);
                setIsSubmitting(false);
            })

        } else {
          
        }

    }

    const onSelectChange = (action, value) => {
        setIsSaving(false);
        const inputMod = { ...inputModel }
        const errorsMod = { ...errorsJson };
        if (action == 'jobTitle') {
            inputMod.jobRole = value

        } else if (action == 'email') {
            if (isValidEmail(value)) {
                inputMod.email = value;
                errorsMod.email = '';
            } else {
                inputMod.email = value;
                errorsMod.email = translate.error.invalid_email
            }

        } else if (action == 'salary') {
            if (isValidSalary(value)) {
                inputMod.salary = value;
                errorsMod.salary = '';
            } else {
                inputMod.salary = value;
                errorsMod.salary = translate.error.expected_salary_error
            }

        } else if (action == 'introduction') {
            inputMod.introduction = value;
        }
        setInputModel(inputMod);
        setErrors(errorsMod);
    }
    function isValidEmail(email) {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return emailRegex.test(email);
    }
    function isValidSalary(value) {
        if (value >= 1) {
            return true;
        } else {
            return false;
        }

    }
    return (
        <>
            <div className="main-control">
                <MenuComponent></MenuComponent>
                <div className="talent-sauce-drop-resume-main">
                    <div className="talent-sauce-drop-resume-overlay-black"></div>
                    <div className="talent-sauce-drop-resume-cover-header-control">
                        <div className="talent-sauce-drop-resume-cover-img"></div>
                        {
                            !isSubmitting &&
                            <FormControl className="talent-sauce-drop-resume-control">
                                <div className="talent-sauce-drop-resume-title-control">
                                    <span className="talent-sauce-drop-resume-title-white">Become a <span className="talent-sauce-drop-resume-title-orange">Talent
                                    { pathName && " From Hackaton Campaign"}
                                    </span></span>
                                </div>
                                <span className="talent-sauce-drop-resume-desc-text">ฝากเรซูเม่ของคุณไว้ เพื่อเปิดโอกาสสู่การทำงานในบริษัทชั้นนำ</span>


                                <div className="talent-sauce-drop-resume-form-control">
                                    <div className="talent-sauce-drop-resume-field-item-33">
                                        <span className="talent-sauce-drop-resume-title">
                                            อัปโหลด เรซูเม่ ของคุณ
                                        </span>
                                        <div className="talent-sauce-drop-resume-upload-file">
                                            <Button onClick={openFilePicker} className="talent-sauce-drop-resume-upload-file-button">เลือกไฟล์</Button>
                                            <span className="talent-sauce-drop-resume-upload-file-text">{
                                                files && files.length > 0 ? files[0].name : "ไม่มีไฟล์ที่เลือก"
                                            }</span>
                                        </div>

                                        {
                                            (isSaving && !inputModel.resume) &&
                                            <span className="talent-sauce-drop-resume-error">{translate.error.input}</span>
                                        }
                                    </div>
                                    <div className="talent-sauce-drop-resume-field-item-33">
                                        <span className="talent-sauce-drop-resume-title">
                                            เลือกประเภทงานที่ต้องการ
                                        </span>
                                        <Autocomplete
                                            options={flattenedRoles.map(group => group.options).flat()}
                                            groupBy={(option) =>
                                                flattenedRoles.find(group => group.options.includes(option)).label
                                            }

                                            value={inputModel?.jobRole}
                                            className="talent-sauce-drop-resume-input"
                                            onInputChange={(event, newValue) => {
                                                onSelectChange("jobTitle", newValue);
                                                // Do something with the selected name
                                            }}
                                            renderInput={(params) => <TextField {...params} placeholder="เลือกประเภทงาน" variant="outlined" />}
                                        />
                                        {
                                            errorsJson.jobRole &&
                                            <span className="talent-sauce-drop-resume-error">{errorsJson.jobRole}</span>
                                        }
                                        {
                                            (isSaving && !inputModel.jobRole) &&
                                            <span className="talent-sauce-drop-resume-error">{translate.error.input}</span>
                                        }
                                    </div>
                                    <div className="talent-sauce-drop-resume-field-item-33">
                                        <span className="talent-sauce-drop-resume-title">
                                            อีเมล
                                        </span>
                                        <TextField id="outlined-basic"
                                            placeholder="ex. talentsauce@gmail.com"
                                            value={inputModel.email}
                                            className="talent-sauce-drop-resume-input" variant="outlined"
                                            type="email" onChange={(e) => onSelectChange("email", e.target.value)} />
                                        {
                                            errorsJson.email &&
                                            <span className="talent-sauce-drop-resume-error">{errorsJson.email}</span>
                                        }
                                        {
                                            (isSaving && !inputModel.email) &&
                                            <span className="talent-sauce-drop-resume-error">{translate.error.input}</span>
                                        }
                                    </div>
                                </div>
                                <div className="talent-sauce-drop-resume-form-control">
                                    <div className="talent-sauce-drop-resume-field-item-50">
                                        <span className="talent-sauce-drop-resume-title">
                                            เงินเดือนที่ต้องการ
                                        </span>
                                        <TextField id="outlined-basic"
                                            placeholder="0 บาท"
                                            value={inputModel.salary}
                                            className="talent-sauce-drop-resume-input" variant="outlined"
                                            type="number" onChange={(e) => onSelectChange("salary", e.target.value)} />
                                        {
                                            errorsJson.salary &&
                                            <span className="talent-sauce-drop-resume-error">{errorsJson.salary}</span>
                                        }
                                        {
                                            (isSaving && !inputModel.salary) &&
                                            <span className="talent-sauce-drop-resume-error">{translate.error.input}</span>
                                        }
                                    </div>
                                    <div className="talent-sauce-drop-resume-field-item-50">
                                        <span className="talent-sauce-drop-resume-title">
                                            แนะนำตัวเองในแบบของคุณ
                                        </span>
                                        <TextareaAutosize
                                            className="talent-sauce-drop-resume-text-area"
                                            minRows={5}
                                            placeholder="เขียนแนะนำตัว"
                                            value={inputModel.introduction}
                                            onChange={(e) => onSelectChange('introduction', e.target.value)} />
                                        {
                                            (isSaving && !inputModel.introduction) &&
                                            <span className="talent-sauce-drop-resume-error">{translate.error.input}</span>
                                        }
                                    </div>

                                </div>
                                <div className="talent-sauce-drop-resume-form-control drop-resume-form-control-full">

                                    <Button className="talent-sauce-drop-resume-submit-button" onClick={clickSubmit}>ส่งเรซูเม่ของคุณ</Button>
                                </div>

                            </FormControl>
                        }
                        {
                            isSubmitting &&
                            <div className="talent-sauce-drop-resume-control">
                                <div className="talent-sauce-drop-resume-loading-control">
                                    <div className="talent-sauce-drop-resume-loading-item">
                                        <CircularProgress className="talent-sauce-drop-resume-loading-progress" />

                                        <span className="talent-sauce-drop-resume-loading-text">
                                            กำลังส่งข้อมูล . . .
                                        </span>
                                    </div>
                                </div>
                            </div>
                        }

                    </div>
                    <div className="talent-sauce-drop-resume-wave"></div>
                    <img src={IMAGE_T} className="talent-sauce-drop-resume-t"></img>
                    <img src={IMAGE_S} className="talent-sauce-drop-resume-s"></img>
                </div >
            </div >
            <Snackbar open={isModalSnack} autoHideDuration={3000} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                onClose={handleCloseModalSnack} >
                <Alert onClose={handleCloseModalSnack} severity="success" sx={{ width: '100%' }}>
                    ส่งประวัติของคุณเรียบร้อย
                </Alert>
            </Snackbar>
        </>
    )
}

export default TalentSauceDropResumeComponent;